import { LOGGED_USER_REQUEST_SUCCEEDED } from '@domain/logged-user/logged-user.state';
import { integrateIntercom, updateIntercomSettings, showProductTour } from './intercom-script';
import { createMiddleware } from '../../../shared/redux/create-middleware';
import { INTERCOM_UPDATE_SETTINGS, INTERCOM_START_PRODUCT_TOUR } from './intercom-script-state';

export const intercomScriptMiddleware = createMiddleware({
    [LOGGED_USER_REQUEST_SUCCEEDED]: (_, action) => {
        integrateIntercom(action.payload.data);
    },
    [INTERCOM_UPDATE_SETTINGS]: (_, action) => {
        updateIntercomSettings(action.payload);
    },
    [INTERCOM_START_PRODUCT_TOUR]: (_, action) => {
        showProductTour(action.payload.productTourId);
    },
});
